simplePathPattern